import { FC } from 'react';
import { Box, Paper, Typography, styled } from '@mui/material';

export type PaperLayoutProps = {
  header: string;
  content: JSX.Element;
  actionArea: JSX.Element;
};

const StyledHeader = styled(Typography)({
  marginTop: 40,
});

const StyledPaper = styled(Paper)({
  minHeight: `calc(100vh - 100px - 80px - 48px - 10vw)`, //100-topbar, 32-footer, 80-header,100-padding, 10vw button
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const StyledActionArea = styled(Box)({
  display: 'grid',
  gridAutoFlow: 'column',
  gap: 40,
  alignSelf: 'center',
  '& > button': {
    width: '10vw',
    height: '10vw',
    borderRadius: '50%',
    marginTop: '-5vw',
  },
});

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const MainPaperLayout: FC<PaperLayoutProps> = ({
  header,
  content,
  actionArea,
}) => {
  return (
    <Container>
      <StyledHeader variant="main" data-testid="page-header">
        {header}
      </StyledHeader>
      <StyledPaper data-testid="page-content">{content}</StyledPaper>
      <StyledActionArea>{actionArea}</StyledActionArea>
    </Container>
  );
};
